import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { ArquivoExportacaoComponent } from './arquivo-exportacao/arquivo-exportacao.component';

const routes: Routes = [
  { path: 'arquivo/exportarTextos', component: ArquivoExportacaoComponent, data: { titulo: 'Exportação de textos dos arquivos' }  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ArquivoRoutingModule { }
